import instance from "../utils/request";
export const userLogin = (userInfo)=>{
    return instance.post('/login',userInfo)
}